import { useState } from 'react';

/** Shows a secret (token / setup link) once with a copy button. */
export function SecretReveal({
  label,
  value,
  note = 'Shown once. Copy it now and store it somewhere safe.',
  onDismiss,
}: {
  label: string;
  value: string;
  note?: string;
  onDismiss?: () => void;
}): JSX.Element {
  const [copied, setCopied] = useState(false);
  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard blocked; user can select manually */
    }
  }
  return (
    <div className="secret-box">
      <div className="secret-box__label">{label}</div>
      <div className="secret-box__row">
        <div className="secret-box__value" onClick={(e) => window.getSelection()?.selectAllChildren(e.currentTarget)}>
          {value}
        </div>
        <button type="button" className="btn btn--ghost" style={{ padding: '6px 10px' }} onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy'}
        </button>
        {onDismiss && (
          <button type="button" className="btn btn--ghost" style={{ padding: '6px 10px' }} onClick={onDismiss}>
            Done
          </button>
        )}
      </div>
      <div className="secret-box__note">{note}</div>
    </div>
  );
}

export function loginLink(token: string): string {
  return `${window.location.origin}/login?token=${encodeURIComponent(token)}`;
}
